let timeout;
export function debounce(callback, wait) {
  return (...args) => {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => callback.apply(context, args), wait);
  };
}
let debounceTimer;
export function debounceWithEventPersist(callback, wait) {
  return (...args) => {
    const context = this;
    args[0].persist();
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => callback.apply(context, args), wait);
  };
}
